export default __webpack_public_path__ + "static/media/jump.ea8c9f12.png";